import React from 'react'
import { Link } from 'react-router-dom'
import LogoAccent from '../../assets/NewDesign/logo-accent.svg'

const FOOTER_LINK_CLASS =
  'text-[16px] font-normal leading-[24px] tracking-[-0.5px] text-[#1A202CB3] no-underline decoration-solid underline-offset-2 transition-colors hover:text-[#1A202C] hover:underline'

const FOOTER_MUTED_CLASS =
  'text-[16px] font-normal leading-[24px] tracking-[-0.5px] text-[#1A202CB3]'

const FOOTER_HEADING_CLASS =
  'mb-[18px] text-[16px] font-semibold leading-[24px] tracking-[-0.5px] text-[#1A202C]'

export default function Footer() {
  return (
    <footer className="w-full bg-[#F7F7F7] font-sans tracking-[-0.5px] text-[#1A202C]">
      <div className="mx-auto max-w-[1280px] px-[80px] pt-[52px]">
        <div className="grid grid-cols-1 gap-10 text-center sm:gap-12 md:grid-cols-3 md:gap-8 lg:gap-12 layout-2col:text-left">
          <div className="flex min-w-0 flex-col items-center layout-2col:items-start gap-[6px] justify-between">
            <div className="mb-[16px] flex items-center justify-center gap-[10px] layout-2col:justify-start">
              <img src={LogoAccent} alt="" className="h-[28px] w-[28px] shrink-0" width={28} height={28} />
              <span className="text-[16px] font-bold leading-none text-[#1A202C]">Дисенс</span>
            </div>
            <div className={`${FOOTER_MUTED_CLASS} flex flex-col items-center gap-0 layout-2col:items-start`}>
              <p>ООО «Страйв-Таск»</p>
              <p>ИНН 9701284389</p>
              <p className="mb-0">ОГРН 1247700309340</p>
            </div>
          </div>

          <div className="flex min-w-0 flex-col items-center layout-2col:items-start gap-[6px]">
            <h3 className={FOOTER_HEADING_CLASS}>Компания</h3>
            <nav className="flex flex-col items-center gap-[12px] layout-2col:items-start" aria-label="Компания">
              <Link to="/" className={FOOTER_LINK_CLASS}>
                О нас
              </Link>
              <Link to="/privacy-policy" className={FOOTER_LINK_CLASS}>
                Политика конфиденциальности
              </Link>
              <Link to="/terms-of-service" className={FOOTER_LINK_CLASS}>
                Публичная оферта
              </Link>
            </nav>
          </div>

          <div className="flex min-w-0 flex-col items-center layout-2col:items-start gap-[6px]">
            <h3 className={FOOTER_HEADING_CLASS}>Контакты</h3>
            <div className="flex flex-col items-center gap-[12px] layout-2col:items-start">
              <a href="mailto:support@striveapp.com" className={`${FOOTER_LINK_CLASS} w-fit`}>
                support@striveapp.com
              </a>
              <a href="tel:+79385435269" className={`${FOOTER_LINK_CLASS} w-fit`}>
                +7 (938) 543-52-69
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-[52px] w-full border-t border-[#1A202C1A]">
        <div className="mx-auto max-w-[1280px] px-[80px] py-[24px] text-center text-[14px] font-normal leading-[22px] tracking-[-0.5px] text-[#1A202CB3]">
          © 2026 ООО «СТРАЙВ‑ТАСК». Все права защищены
        </div>
      </div>
    </footer>
  )
}
